import moment from "moment";
const axios = require("axios");
const GoogleAPIKey = "AIzaSyC7HQkfJkwVLGTsvUwAIy4JH3bdlE7fyzE";

export const getMonthString = (month) => {
  switch (month) {
    case 0:
      return "Jan";
    case 1:
      return "Feb";
    case 2:
      return "Mar";
    case 3:
      return "Apr";
    case 4:
      return "May";
    case 5:
      return "Jun";
    case 6:
      return "Jul";
    case 7:
      return "Aug";
    case 8:
      return "Sep";
    case 9:
      return "Oct";
    case 10:
      return "Nov";
    case 11:
      return "Dec";
    default:
      return "Jan";
  }
};
export const getDay = (day) => {
  switch (day) {
    case 0:
      return "Sunday";
    case 1:
      return "Monday";
    case 2:
      return "Tuesday";
    case 3:
      return "Wednesday";
    case 4:
      return "Thursday";
    case 5:
      return "Friday";
    case 6:
      return "Saturday";
  }
};
export const clearZero = function (str) {
  if (str.charAt(0) === "0") str = str.replace("0", "");
  return str;
};
export function isDateValidate(date) {
  if (
    date &&
    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
      date
    )
  )
    return true;
  else return false;
}
// export const getAddresses = async (postcode) => {
//   try {
//     let response = await fetch(
//       `https://api.getAddress.io/find/${postcode}?api-key=TAOlpULvxkm8OUK_tN6RzA21029`,
//       {
//         method: "GET",
//       }
//     );
//     let res = await response.json();
//     return res;
//   } catch (err) {
//     return err;
//   }
// };
export const getaddress = async (postcode) => {
  try {
    let url = "";
    url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postcode}&key=${GoogleAPIKey}`;
    let response = await fetch(url, {
      method: "GET",
    });
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};
// Wednesday 10/21
export const getDayStr = (date) => {
  return moment(date).format("dddd DD/MM");
};
export const timefromSeconds = (seconds) => {
  const dateM = moment(new Date(parseInt(seconds))).format("hh:mm");
  return dateM;
};
export const getTimestring = (time) => {
  const { hh, mm, of, utc } = time;
  return hh + ":" + mm + " " + of + " " + "UTC: " + utc + ":00";
};
export const getStringfromSeconds = function (time) {
  var t = new Date(parseInt(time));
  var dd = String(t.getDate()).padStart(2, "0");
  var mm = String(t.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = t.getFullYear();
  t = dd + "." + mm + "." + yyyy.toString().substr(2, 2);
  return t;
};
export const getTimeStringfromSeconds = function (time) {
  var t = new Date(parseInt(time));
  var dd = String(t.getDate()).padStart(2, "0");
  var mm = String(t.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = t.getFullYear();
  var hours = t.getHours();
  var minutes = t.getMinutes();
  var seconds = t.getSeconds();
  t =
    hours +
    ":" +
    minutes +
    ":" +
    seconds +
    " on " +
    dd +
    "." +
    mm +
    "." +
    yyyy.toString().substr(2, 2);
  return t;
};
export const sendNotification = async (player_ids, content) => {
  let contents = { en: content };
  try {
    let result = await axios.post(
      "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/sendNotification",
      {
        player_ids: player_ids,
        content: contents,
      }
    );
    return result;
  } catch (err) {
    throw Error(err);
  }
};
export const weekCount = (year, month_number) => {
  // month_number is in the range 1..12

  var firstOfMonth = new Date(year, month_number - 1, 1);
  var lastOfMonth = new Date(year, month_number, 0);

  var used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();

  return Math.ceil(used / 7);
};

export function similarity(s1, s2) {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (
    (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength)
  );
}
function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = new Array();
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0) costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}
export function getMondaysChange(m) {
  var d = new Date(),
    mondaysChange = [];
  //empty the array
  mondaysChange.length = 0;

  //change the type of m to number
  m = +m;

  d.setDate(1);
  d.setMonth(m);
  while (d.getDay() !== 1) {
    d.setDate(d.getDate() + 1);
  }

  // Get all the other Mondays in the month
  while (d.getMonth() === m) {
    mondaysChange.push(new Date(d.getTime()));
    d.setDate(d.getDate() + 7);
  }
  return mondaysChange;
}
export function idealTextColor(bgColor) {
  if (!bgColor) {
    return "#000000";
  }
  var nThreshold = 105;
  var components = getRGBComponents(bgColor);
  var bgDelta =
    components.R * 0.299 + components.G * 0.587 + components.B * 0.114;

  return 255 - bgDelta < nThreshold ? "#000000" : "#ffffff";
}

function getRGBComponents(color) {
  var r = color.substring(1, 3);
  var g = color.substring(3, 5);
  var b = color.substring(5, 7);

  return {
    R: parseInt(r, 16),
    G: parseInt(g, 16),
    B: parseInt(b, 16),
  };
}

const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const isDeepEqual = (object1, object2) => {
  const objKeys1 = Object.keys(object1);
  const objKeys2 = Object.keys(object2);

  if (objKeys1.length !== objKeys2.length) {
    return false;
  }

  for (var key of objKeys1) {
    const value1 = object1[key];
    const value2 = object2[key];

    const isObjects = isObject(value1) && isObject(value2);

    if (
      (isObjects && !isDeepEqual(value1, value2)) ||
      (!isObjects && value1 !== value2)
    ) {
      return false;
    }
  }
  return true;
};

export const regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;



// WEBPACK FOOTER //
// ./src/functions/index.js